var _rect, _title, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevisionReviewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 5",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M4.859999999999999,6.475973261123391 V4.85597326112339 H2.4999999999999982 a6.47,6.47 0 0 1 11.870000000000001,1.62 h1.6700000000000004 A8.1,8.1 0 0 0 1.6199999999999983,3.2459732611233907 V1.61597326112339 H-1.3322676295501878e-15 v4.86 z",
    className: "",
    fillOpacity: 1,
    fill: "#4a90d6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M11.149999999999999,9.715973261123391 v1.62 h2.35 A6.46,6.46 0 0 1 1.6699999999999982,9.715973261123391 H-1.3322676295501878e-15 a8.1,8.1 0 0 0 14.42,3.23 v1.6300000000000003 h1.62 V9.715973261123391 z",
    className: "",
    fillOpacity: 1,
    fill: "#4a90d6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M6.009999999999998,10.66597326112339 H7.349999999999998 V5.52597326112339 H6.009999999999998 zm2.68,-5.14 v5.14 h1.33 V5.52597326112339 z",
    className: "",
    fillOpacity: 1,
    fill: "#4a90d6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevisionReviewIcon);
export default __webpack_public_path__ + "static/media/revision_review_icon.dfc4a9dcb785226b0cec557bed442bcd.svg";
export { ForwardRef as ReactComponent };